import { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import http from 'services/http';

export default function DescargaGateway() {
    const [destino, setDestino] = useState(null);

    useEffect(() => {
        http.get('/bancas/minha-banca')
            .then(res => {
                const banca = res.data.data;
                const usaAutomatica = !!banca.descarga_banca_id || !!banca.is_descarga_destino;
                setDestino(usaAutomatica ? '/descarga-automatica' : '/descarga');
            })
            .catch(() => {
                setDestino('/descarga');
            });
    }, []);

    if (!destino) return <div className="loader" />;

    return <Redirect to={destino} />;
}
